"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Current: function() {
        return _FormRichSelectCurrent.FormRichSelectCurrent;
    },
    Item: function() {
        return _FormRichSelectItem.FormRichSelectItem;
    },
    Menu: function() {
        return _FormRichSelectMenu.FormRichSelectMenu;
    },
    Select: function() {
        return _FormRichSelect.FormRichSelect;
    }
});
const _FormRichSelect = require("./FormRichSelect");
const _FormRichSelectCurrent = require("./FormRichSelectCurrent/FormRichSelectCurrent");
const _FormRichSelectItem = require("./FormRichSelectItem/FormRichSelectItem");
const _FormRichSelectMenu = require("./FormRichSelectMenu/FormRichSelectMenu");

//# sourceMappingURL=index.js.map